"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheAdvantage() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="146437" id="consent" className="bg-background text-foreground bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-background via-background to-muted/20 w-full overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-stretch">
          
          {}
          <div ref={textRef} className={`lg:col-span-7 py-16 lg:py-32 lg:pr-16 relative flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="flex items-center gap-4 mb-8">
              <div className="w-12 h-px bg-primary"></div>
              <span className="font-mono text-primary text-sm tracking-widest uppercase">
                Privacy
              </span>
            </div>
            
            <h2 className="font-serif text-4xl md:text-5xl lg:text-7xl leading-none mb-8 uppercase tracking-tight">
              Consent Protocol
            </h2>
            
            <p className="text-muted-foreground text-lg md:text-xl leading-relaxed max-w-2xl font-serif">
              We prioritize your digital security and personal sovereignty. By configuring your preferences, you define the parameters of data interaction within our logistics architecture. Our framework guarantees that your privacy is upheld with technical precision, ensuring complete transparency and regulatory compliance across every global node.
            </p>

            {}
            <div className="hidden lg:block absolute right-0 top-0 bottom-0 w-px bg-border"></div>
          </div>

          {}
          <div ref={imgRef} className={`lg:col-span-5 relative min-h-[400px] lg:min-h-full transition-all duration-1000 delay-300 ease-out ${isImgVisible ? "opacity-100" : "opacity-0"}`}>
            {}
            <div className="absolute inset-0 bg-muted/30 z-10 mix-blend-multiply"></div>
            
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576388/img/technical_ui_wireframe.png" alt="Technical privacy interface wireframe" className="absolute inset-0 w-full h-full object-cover grayscale mix-blend-luminosity opacity-60" />
            
            {}
            <div className="block lg:hidden absolute top-0 left-0 right-0 h-px bg-border"></div>
          </div>

        </div>
      </div>
    </section>;
}